import { Component, Input, OnInit } from '@angular/core';
import { IonSpinner } from '@ionic/angular/standalone';

@Component({
  selector: 'app-spinner-message',
  templateUrl: './spinner-message.component.html',
  styleUrls: ['./spinner-message.component.scss'],
  imports: [IonSpinner]
})
export class SpinnerMessageComponent implements OnInit {
  @Input() message = '';
  constructor() { }

  ngOnInit(): void {
      // console.log(`DEBUG ${this.constructor.name} message:`, this.message)
  }
}
